import WebFinishPurchase from './WebFinishPurchase';
export default WebFinishPurchase;
